import React, { createContext } from 'react';

const UserContext = React.createContext('skunk')

//export const UserProvider = UserContext.Provider
//export const UserConsumer = UserContext.Consumer

export default UserContext

/*Even though half of this is commented out or not used, this .js file is still used for creating the context in App.js which makes it very important.
 * */